export const AUTH_CALLBACK_ERROR_PARAM = 'error'
export const AUTH_CALLBACK_ERROR_DESCRIPTION_PARAM = 'error_description'
export const AUTH_CALLBACK_ACCESS_DENIED_ERROR = 'access_denied'
